export enum ResetRequestError {
  Throttled = '<b>This request have been throttled!</b><br>Please try again.',
  ErrorSendingRequest = '<h3>Error!</h3>Could not send reset request. Please contact support.',
}
